import React from "react";
import { Checkbox } from "@blueprintjs/core";
import { useTranslation } from "react-i18next";

const FEATURES = [
    { value: "show-stats", translationKey: "showStats" },
    { value: "invoices", translationKey: "invoices" },
    { value: "delivery-notes", translationKey: "deliveryNotes" },
    { value: "stocks", translationKey: "stock" },
    { value: "technical-sheets", translationKey: "technicalsSheets" },
    { value: "documentation", translationKey: "documentations" },
    { value: "transportation", translationKey: "transportation" },
    { value: "chat", translationKey: "chat" },
];

const FeaturesSelector = ({ features = [], onChange }) => {
    const { t } = useTranslation("users");

    const toggleFeature = (feature) => {
        const index = features.indexOf(feature);
        const newFeatures = [...features];
        index >= 0 ? newFeatures.splice(index, 1) : newFeatures.push(feature);
        onChange(newFeatures);
    };

    return (
        <div style={containerStyle}>
            <label style={labelStyle}>{t("funcWithAccess.label")}</label>
            {FEATURES.map(({ value, translationKey }) => (
                <Checkbox
                    key={value}
                    label={t(`funcWithAccess.${translationKey}`)}
                    checked={features.indexOf(value) >= 0}
                    onChange={() => toggleFeature(value)}
                    style={checkStyle}
                />
            ))}
        </div>
    );
};

export default FeaturesSelector;

const containerStyle = {
    marginBottom: "15px",
    width: "calc(50% - 10px)"
};

const labelStyle = {
    fontWeight: "bold",
    fontSize: "12px"
};

const checkStyle = {
    margin: "10px",
    fontSize: "12px",
    marginLeft: "20px"
};
